<template>

    <b-form-checkbox
      v-model="checked"
      value="1"
      class="pageright"
      unchecked-value="0"
      @change="onChange"
    >
    </b-form-checkbox>

</template>

<script>
    export default {
        name: "MagazinePageRightCheckboxComponent",
        props: ['checkedIn', 'pageId', 'userId', 'magazineId'],
        data() {
            return {
                checked: this.checkedIn
            }
        },
        methods: {
            onChange(value) {
                this.$emit('clicked', {user_id: this.userId, page_id: this.pageId, right: value});
            }
        },
        watch: {
            checkedIn(value) {
                this.checked = value;
            }
        }
    }
</script>

<style scoped>

    .pageright {
        padding-left: 30px !important;
    }

</style>